<template>
    <div>
        <v-card v-for="(change, index) in changes" :key="change.id" :class="index > 0 ? 'mt-3' : ''">
            <v-card-subtitle class="py-2 text-right">
                <span v-if="!change.is_updated">Geplante Änderung am</span>
                <span v-else>Am</span>
                {{ change.update_at }}
                durch
                {{change.creator_name}}
            </v-card-subtitle>
            <v-card-text v-if="change.properties.email" class="py-2">
                <div class="font-weight-bold">E-Mail-Adresse</div>
                {{change.original.email}}
                <v-chip label small class="mr-2 ml-2"><v-icon>mdi-arrow-right</v-icon></v-chip>
                {{change.properties.email}}
            </v-card-text>
            <v-card-text v-if="change.properties.staff_number" class="py-2">
                <div class="font-weight-bold">Personalnummer</div>
                {{change.original.staff_number}}
                <v-chip label small class="mr-2 ml-2"><v-icon>mdi-arrow-right</v-icon></v-chip>
                {{change.properties.staff_number}}
            </v-card-text>
            <v-card-text v-if="change.properties.first_name" class="py-2">
                <div class="font-weight-bold">Vorname</div>
                {{change.original.first_name}}
                <v-chip label small class="mr-2 ml-2"><v-icon>mdi-arrow-right</v-icon></v-chip>
                {{change.properties.first_name}}
            </v-card-text>
            <v-card-text v-if="change.properties.last_name" class="py-2">
                <div class="font-weight-bold">Nachname</div>
                {{change.original.last_name}}
                <v-chip label small class="mr-2 ml-2"><v-icon>mdi-arrow-right</v-icon></v-chip>
                {{change.properties.last_name}}
            </v-card-text>
            <v-card-text v-if="change.properties.orga_unit_id" class="py-2">
                <div class="font-weight-bold">Organisationseinheit</div>
                <v-row>
                    <v-col md="auto" sm="auto">
                        <v-select
                            v-model="change.original.orga_unit_id"
                            :items="orga_units"
                            item-text="name"
                            item-value="id"
                            disabled
                            dense
                            hide-details
                            outlined/>
                    </v-col>
                    <v-col md="auto" sm="auto">
                        <v-chip label small class="my-2"><v-icon>mdi-arrow-right</v-icon></v-chip>
                    </v-col>
                    <v-col md="auto" sm="auto">
                        <v-select
                            v-model="change.properties.orga_unit_id"
                            :items="orga_units"
                            item-text="name"
                            item-value="id"
                            dense
                            disabled
                            hide-details
                            outlined/>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text v-if="change.type === 'supervisors'" class="py-2">
                <div class="font-weight-bold">Vorgesetzte</div>
                <v-row>
                    <v-col md="auto">
                        <v-autocomplete
                            v-model="change.original"
                            multiple
                            :items="listSupervisors"
                            outlined
                            dense
                            disabled
                            chips
                            hide-details
                        />
                    </v-col>
                    <v-col md="auto">
                        <v-chip label small class="my-2"><v-icon>mdi-arrow-right</v-icon></v-chip>
                    </v-col>
                    <v-col md="auto">
                        <v-autocomplete
                            v-model="change.properties"
                            multiple
                            :items="listSupervisors"
                            outlined
                            dense
                            disabled
                            chips
                            hide-details
                        />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: ['changes', 'listSupervisors', 'orga_units'],
}
</script>

<style scoped>

</style>